import { useState, useCallback, useMemo, type ReactNode } from 'react';
import {
  FiltersContext,
  type FilterValue,
  type FiltersContextValue,
} from './FiltersContext.context';

interface FiltersProviderProps {
  children: ReactNode;
  initialFilters?: Record<string, FilterValue>;
}

// Reset target: a filter left out here falls back to the neutral value its own group declares.
const DEFAULT_FILTERS: Record<string, FilterValue> = {};

export function FiltersProvider({ children, initialFilters = {} }: FiltersProviderProps) {
  const [filters, setFilters] = useState<Record<string, FilterValue>>(initialFilters);

  const setFilter = useCallback((name: string, value: FilterValue) => {
    setFilters(prev => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters(DEFAULT_FILTERS);
  }, []);

  const value = useMemo<FiltersContextValue>(
    () => ({ filters, setFilter, resetFilters }),
    [filters, setFilter, resetFilters]
  );

  return (
    <FiltersContext value={value}>
      {children}
    </FiltersContext>
  );
}
